import React, { useState, useEffect } from "react";
import { Button, message } from "antd";
import { instance } from "utils/axios";
import { useNavigate } from "react-router-dom";
// 5.31 10:00
// 6.7 10:00
// 6.21 10:00
// 6.28 10:00
const meetingTimes = [
  { label: "2025-05-31 10:00", value: "2025-05-31 10:00" },
  { label: "2025-06-07 10:00", value: "2025-06-07 10:00" },
  { label: "2025-06-21 10:00", value: "2025-06-21 10:00" },
  { label: "2025-06-28 10:00", value: "2025-06-28 10:00" },
];

function ChooseMeetingPage({ onConfirm }) {
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState(null);
   const [loading, setLoading] = useState(false);
   const navigate = useNavigate();
 useEffect(() => {
   setLoading(true);
   instance({
     method: "get",
     url: `/applicant/admissions2/stag9`,
   })
     .then((res) => {
   
       setData(res.data);
     })
     .catch((err) => {})
     .then(() => setLoading(false));
 }, []);
  const handleSelect = (value) => {
    setSubmitting(true);
  
     instance({
       method: "put",
       url: "/applicant/admissions2/stag9",
       data: {
         answer: value,
       },
     })
       .then((res) => {
         message.success("Хоёрдугаар шатны цаг амжилттай сонгогдлоо.");
         navigate("/");
       })
       .catch((err) => {})
       .finally(() => {
         setSubmitting(false);
       });
  };



  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white space-y-6 p-6">
      <h1 className="text-2xl md:text-3xl font-bold text-primary mb-4">
        2-р шатны цаг сонгох*
      </h1>
      {data ? (
        meetingTimes.map((time) => (
          <Button
            key={time.value}
            size="large"
            type="primary"
            loading={submitting}
            onClick={() => handleSelect(time.value)}
            style={{
              backgroundColor: "#f2cd30",
              borderColor: "#f2cd30",
              color: "#5c1090",
               whiteSpace: "normal",
              fontWeight: "bold",
              width: "100%",
              maxWidth: 400,
              height: "auto",
              fontSize: "18px",
            }}
          >
            {time.label}
          </Button>
        ))
      ) : (
        <>Data Not Found</>
      )}
    </div>
  );
}

export default ChooseMeetingPage;
